import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { ServicesShowcase, ProcessSteps, CTA } from "../components/Sections";

export default function Services() {
  return (
    <Layout>
      <Seo
        title="Services & Products Engineered for Scale"
        description="Full-cycle software engineering, cognitive AI, dedicated infrastructure, and sovereign enterprise platforms: Software Development, AI Solutions, IoT & Automation, Cybersecurity (Guardian), Cloud Infrastructure, Technology Consultancy, nORBIT Enterprise OS, and Reach Growth Engine."
        keywords="Services & Products Engineered for Scale, Neuravolt services, AI development, custom software, IoT automation, cybersecurity, cloud infrastructure, technology consultancy, nORBIT, Reach"
        path="/services"
      />

      <PageHero
        eyebrow="Capabilities & Products"
        title={<>Services & Products Engineered for <span className="text-gradient">Scale</span></>}
        sub="Full-cycle software engineering, cognitive AI, dedicated infrastructure, and sovereign enterprise platforms."
      />
      <ServicesShowcase isPage={true} />
      <ProcessSteps />
      <CTA />
    </Layout>
  );
}
